// eslint-disable-next-line no-restricted-imports
import { useOrderGetByIdQuery } from 'api/generated/graphql';
import { parseOrderEntity, useError } from 'api/helpers';

export const useOrderGetById = (id: string) => {
  const {
    data,
    loading,
    error: apolloError,
  } = useOrderGetByIdQuery({ variables: { id } });

  const error = useError(apolloError);

  return {
    order: data?.order ? parseOrderEntity(data.order) : null,
    loading,
    error,
    serverError: apolloError,
  };
};
